/**
 * Standard UTM attribution parameters, captured from the landing URL and
 * forwarded to the database and Salesforce alongside a form submission.
 */
export type UtmParams = {
  campaign?: string;
  medium?: string;
  source?: string;
  content?: string;
  term?: string;
};

const UTM_KEYS: (keyof UtmParams)[] = ['campaign', 'medium', 'source', 'content', 'term'];

/**
 * Extracts `utm_*` values from a query object (e.g. resolved `searchParams`).
 *
 * @param query - Flat key/value map of query parameters
 * @returns A `UtmParams` object containing only the keys that were present
 */
export function parseUtmParams(query: Record<string, string | string[] | undefined>): UtmParams {
  return UTM_KEYS.reduce<UtmParams>((utm, key) => {
    const value = query[`utm_${key}`];
    const first = Array.isArray(value) ? value[0] : value;
    return first ? { ...utm, [key]: first } : utm;
  }, {});
}
